module.exports = __webpack_public_path__ + "static/cosygiraffewhite-28554d3d585170cba0335079fde3dd02.jpeg";